﻿

var GroTranslator = GroTranslator || (function (allTranslations) {
    var _translations = allTranslations || {};

    function set(key, translation) {
        key = key.toLowerCase();

        _translations[key] = translation;
    }

    function setAll(translations) {
        var keys = Object.keys(translations);

        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            this.set(key, translations[key]);
        }
    }

    function get(key) {
        key = key.toLowerCase();

        if (_translations[key]) {
            return _translations[key];
        }
        console.error("Translation for key " + key + " not found. Add key to x-lm-translations in _Scripts.cshtml or current view.");
        return key;
    }

    return {
        get: get,
        set: set,
        setAll: setAll
    };
})();

$(function () {
    var allTranslations = {};

    $('script[type="text/x-lm-translations"]').each(function (i, translationScript) {
        var translations = JSON.parse(translationScript.innerText);
        $.extend(allTranslations, translations);
    });

    GroTranslator.setAll(allTranslations);
});

export default GroTranslator;